import React, { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/store";

export default function ShareButtons({ url, text, label }) {
  const { t } = useApp();
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;

  const links = [
    { key: "whatsapp", label: "WhatsApp", color: "#25D366", href: `https://wa.me/?text=${enc(text + " " + url)}` },
    { key: "facebook", label: "Facebook", color: "#1877F2", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { key: "twitter", label: "X", color: "#0A0B10", href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
    { key: "reddit", label: "Reddit", color: "#FF4500", href: `https://www.reddit.com/submit?url=${enc(url)}&title=${enc(text)}` },
  ];

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Link copied"); setTimeout(() => setCopied(false), 1800); }
    catch { toast.error("Could not copy"); }
  };

  return (
    <div className="rounded-2xl border border-gray-200 p-5" data-testid="share-buttons">
      <div className="mb-3 flex items-center gap-2 font-display font-bold text-gray-900"><Share2 size={16} className="text-[#002FA7]" /> {label || t("share")}</div>
      <div className="flex flex-wrap gap-2">
        {links.map((l) => (
          <button key={l.key} data-testid={`share-${l.key}`} onClick={() => window.open(l.href, "_blank", "noopener,width=640,height=640")}
            className="rounded-full px-4 py-2 text-sm font-bold text-white transition-transform hover:-translate-y-0.5" style={{ backgroundColor: l.color }}>
            {l.label}
          </button>
        ))}
        <button data-testid="share-copy" onClick={copy}
          className="inline-flex items-center gap-1.5 rounded-full border border-gray-300 px-4 py-2 text-sm font-bold text-gray-700 transition-colors hover:bg-gray-50">
          {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
}
